import {useMutation, useQueryClient} from '@github-ui/react-query'
import {fetchCAPI} from '../utils/fetch-capi'
import {taskArchiveApiPath} from '../utils/api-url-helpers'
import {agentTaskQueryKey} from './use-task'
import {agentTasksQueryKey} from './useTasks'

interface UseArchiveTaskArgs {
  taskId?: string
  repoOwner?: string
  repoName?: string
}

export function useArchiveTask({taskId, repoOwner, repoName}: UseArchiveTaskArgs) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['archiveTask', repoOwner, repoName, taskId],
    mutationFn: async () => {
      if (!taskId) {
        throw new Error('taskId is required')
      }

      const path = taskArchiveApiPath(taskId, repoOwner, repoName)
      const response = await fetchCAPI({
        path,
        method: 'POST',
      })
      return response
    },
    onSuccess: () => {
      // Invalidate task/tasks queries to refetch the task list
      const taskQueryKey = agentTaskQueryKey(repoOwner, repoName, taskId)
      queryClient.invalidateQueries({queryKey: taskQueryKey})
      if (repoOwner && repoName) {
        queryClient.invalidateQueries({queryKey: ['repo-tasks', repoOwner, repoName]})
      }
      queryClient.invalidateQueries({queryKey: agentTasksQueryKey})
    },
  })
}
